<template>
  <v-dialog v-model="vDialogShow" max-width="1000px" hpersistent>
    <v-card>
      <v-container fluid>
        <v-row justify="center">
          <v-col cols="12">
            <h1>アカウント申請却下</h1>
          </v-col>
        </v-row>
        <v-row justify="center" v-if="errors.length > 0">
          <v-col cols="12">
            <mp-error :errors="errors" message-key="message.admin.account.error." />
          </v-col>
        </v-row>
        <div>
          <v-checkbox class="mail-send" label="申請却下メールを送信する" v-model="view.isSendMail"></v-checkbox>
        </div>
        <v-row justify="center">
          <v-col cols="4">
            <mp-label>メール件名<span v-if="view.isSendMail" class="red--text">※</span></mp-label>
          </v-col>
          <v-col cols="8">
            <mp-input-box class="mail-subject-card">
              <v-text-field
                hide-details
                solo
                :disabled="!view.isSendMail"
                v-model="mail.subject"
                maxlength="100"
              >
              </v-text-field>
            </mp-input-box>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="4">
            <mp-label>メール本文<span v-if="view.isSendMail" class="red--text">※</span></mp-label>
          </v-col>
          <v-col cols="8">
            <v-textarea
              hide-details
              solo
              class="mail-body"
              :disabled="!view.isSendMail"
              v-model="mail.body"
              maxlength="20000"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12">
            <hr/>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col
            cols="4"
            class="text-center"
          >
            <mp-button wide @click="vDialogShow = false">閉じる</mp-button>
          </v-col>
          <v-col
            cols="4"
            class="text-center"
          >
            <mp-button red wide @click="dialog.rejectConfirm = true">却下</mp-button>
            <mp-dialog reject :show="dialog.rejectComplete" @clickOk="goList"/>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <mp-dialog
      reject confirm
      :show="dialog.rejectConfirm"
      @clickCancel="dialog.rejectConfirm = false"
      @clickOk="goReject"
    />
  </v-dialog>
</template>

<script>
import MpLabel from '@/components/item/MpLabel.vue'
import MpInputBox from '@/components/item/MpInputBox.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpDialog from '@/components/item/MpDialog.vue'
import MpError from '@/components/item/MpError.vue'
import { AdminAccountEntry } from '@/api'

export default {
  components: {
    MpLabel,
    MpInputBox,
    MpButton,
    MpDialog,
    MpError
  },
  data () {
    return {
      dialog: {
        rejectConfirm: false,
        rejectComplete: false
      },
      view: {
        isSendMail: false
      },
      rawErrors: []
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    accountEntryId: {
      required: true
    },
    mail: {
      type: Object,
      default: () => {
        return {
          subject: '',
          body: ''
        }
      }
    }
  },
  methods: {
    async goReject () {
      // ダイアログ非表示
      this.dialog.rejectConfirm = false

      const rejectMailList = []
      if (this.view.isSendMail) {
        rejectMailList.push({
          accountEntryId: this.accountEntryId,
          subject: this.mail.subject,
          body: this.mail.body
        })
      }

      await AdminAccountEntry.reject({
        accountEntryIdList: [this.accountEntryId],
        rejectMailList: rejectMailList
      })
        .then(() => { this.dialog.rejectComplete = true })
        .catch(error => { this.rawErrors = error.messages })
    },
    goList () {
      // 一覧画面に戻る
      this.$router.push({ path: '/admin/account/entry/list' })
    }
  },
  computed: {
    vDialogShow: {
      get () {
        return this.show
      },
      set (newVal) {
        this.$emit('change-show', newVal)
      }
    },
    errors () {
      const errors = []
      for (const error of this.rawErrors) {
        errors.push({
          errorType: error.errorType,
          msg: error.msg,
          param: error.param.replace(/\[[0-9]{1,}\]/, '')
        })
      }
      return errors
    }
  }
}
</script>
<style>
  .mail-send label{
    color: rgba(0, 0, 0, 0.87) !important;
  }
  .mail-subject-card.v-card.v-sheet.v-sheet--tile{
    padding: 0 !important;
  }
  .mail-body textarea {
    min-height: 550px;
  }
</style>
